/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AirTravelRequest } from '../models';
// @ts-ignore
import type { CarRentalRequest } from '../models';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FormulaCalculationResponse } from '../models';
// @ts-ignore
import type { HotelStayRequest } from '../models';
// @ts-ignore
import type { RailTravelRequest } from '../models';
// @ts-ignore
import type { RoadTravelRequest } from '../models';
/**
 * CalculationServiceTravelApi - axios parameter creator
 */
export const CalculationServiceTravelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate passenger air travel emissions
         * @param {AirTravelRequest} airTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airTravel: async (airTravelRequest: AirTravelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'airTravelRequest' is not null or undefined
            assertParamExists('airTravel', 'airTravelRequest', airTravelRequest)
            const localVarPath = `/calculation/v1/calculate/travel/air`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(airTravelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate emissions with car rental
         * @param {CarRentalRequest} carRentalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carRentalTravel: async (carRentalRequest: CarRentalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carRentalRequest' is not null or undefined
            assertParamExists('carRentalTravel', 'carRentalRequest', carRentalRequest)
            const localVarPath = `/calculation/v1/calculate/travel/car-rental`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carRentalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate hotel stay emissions
         * @param {HotelStayRequest} hotelStayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hotelStayTravel: async (hotelStayRequest: HotelStayRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hotelStayRequest' is not null or undefined
            assertParamExists('hotelStayTravel', 'hotelStayRequest', hotelStayRequest)
            const localVarPath = `/calculation/v1/calculate/travel/hotel-stay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hotelStayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate passenger rail travel emissions
         * @param {RailTravelRequest} railTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        railTravel: async (railTravelRequest: RailTravelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'railTravelRequest' is not null or undefined
            assertParamExists('railTravel', 'railTravelRequest', railTravelRequest)
            const localVarPath = `/calculation/v1/calculate/travel/rail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(railTravelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate road travel emissions
         * @param {RoadTravelRequest} roadTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roadTravel: async (roadTravelRequest: RoadTravelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roadTravelRequest' is not null or undefined
            assertParamExists('roadTravel', 'roadTravelRequest', roadTravelRequest)
            const localVarPath = `/calculation/v1/calculate/travel/road`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roadTravelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceTravelApi - functional programming interface
 */
export const CalculationServiceTravelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceTravelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate passenger air travel emissions
         * @param {AirTravelRequest} airTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async airTravel(airTravelRequest: AirTravelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.airTravel(airTravelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceTravelApi.airTravel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate emissions with car rental
         * @param {CarRentalRequest} carRentalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carRentalTravel(carRentalRequest: CarRentalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carRentalTravel(carRentalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceTravelApi.carRentalTravel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate hotel stay emissions
         * @param {HotelStayRequest} hotelStayRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hotelStayTravel(hotelStayRequest: HotelStayRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hotelStayTravel(hotelStayRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceTravelApi.hotelStayTravel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate passenger rail travel emissions
         * @param {RailTravelRequest} railTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async railTravel(railTravelRequest: RailTravelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.railTravel(railTravelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceTravelApi.railTravel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate road travel emissions
         * @param {RoadTravelRequest} roadTravelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roadTravel(roadTravelRequest: RoadTravelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roadTravel(roadTravelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceTravelApi.roadTravel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceTravelApi - factory interface
 */
export const CalculationServiceTravelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceTravelApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate passenger air travel emissions
         * @param {CalculationServiceTravelApiAirTravelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airTravel(requestParameters: CalculationServiceTravelApiAirTravelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.airTravel(requestParameters.airTravelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate emissions with car rental
         * @param {CalculationServiceTravelApiCarRentalTravelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carRentalTravel(requestParameters: CalculationServiceTravelApiCarRentalTravelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.carRentalTravel(requestParameters.carRentalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate hotel stay emissions
         * @param {CalculationServiceTravelApiHotelStayTravelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hotelStayTravel(requestParameters: CalculationServiceTravelApiHotelStayTravelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.hotelStayTravel(requestParameters.hotelStayRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate passenger rail travel emissions
         * @param {CalculationServiceTravelApiRailTravelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        railTravel(requestParameters: CalculationServiceTravelApiRailTravelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.railTravel(requestParameters.railTravelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate road travel emissions
         * @param {CalculationServiceTravelApiRoadTravelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roadTravel(requestParameters: CalculationServiceTravelApiRoadTravelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.roadTravel(requestParameters.roadTravelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for airTravel operation in CalculationServiceTravelApi.
 */
export interface CalculationServiceTravelApiAirTravelRequest {
    readonly airTravelRequest: AirTravelRequest
}

/**
 * Request parameters for carRentalTravel operation in CalculationServiceTravelApi.
 */
export interface CalculationServiceTravelApiCarRentalTravelRequest {
    readonly carRentalRequest: CarRentalRequest
}

/**
 * Request parameters for hotelStayTravel operation in CalculationServiceTravelApi.
 */
export interface CalculationServiceTravelApiHotelStayTravelRequest {
    readonly hotelStayRequest: HotelStayRequest
}

/**
 * Request parameters for railTravel operation in CalculationServiceTravelApi.
 */
export interface CalculationServiceTravelApiRailTravelRequest {
    readonly railTravelRequest: RailTravelRequest
}

/**
 * Request parameters for roadTravel operation in CalculationServiceTravelApi.
 */
export interface CalculationServiceTravelApiRoadTravelRequest {
    readonly roadTravelRequest: RoadTravelRequest
}

/**
 * CalculationServiceTravelApi - object-oriented interface
 */
export class CalculationServiceTravelApi extends BaseAPI {
    /**
     * 
     * @summary Calculate passenger air travel emissions
     * @param {CalculationServiceTravelApiAirTravelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public airTravel(requestParameters: CalculationServiceTravelApiAirTravelRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceTravelApiFp(this.configuration).airTravel(requestParameters.airTravelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate emissions with car rental
     * @param {CalculationServiceTravelApiCarRentalTravelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carRentalTravel(requestParameters: CalculationServiceTravelApiCarRentalTravelRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceTravelApiFp(this.configuration).carRentalTravel(requestParameters.carRentalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate hotel stay emissions
     * @param {CalculationServiceTravelApiHotelStayTravelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hotelStayTravel(requestParameters: CalculationServiceTravelApiHotelStayTravelRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceTravelApiFp(this.configuration).hotelStayTravel(requestParameters.hotelStayRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate passenger rail travel emissions
     * @param {CalculationServiceTravelApiRailTravelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public railTravel(requestParameters: CalculationServiceTravelApiRailTravelRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceTravelApiFp(this.configuration).railTravel(requestParameters.railTravelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate road travel emissions
     * @param {CalculationServiceTravelApiRoadTravelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public roadTravel(requestParameters: CalculationServiceTravelApiRoadTravelRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceTravelApiFp(this.configuration).roadTravel(requestParameters.roadTravelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

